import React, { ComponentProps, PropsWithChildren } from "react";
import connectUserAndChat, { User } from "~/common/Store/connectUserAndChat";
interface WebPlusAdProps extends ComponentProps<"div">, PropsWithChildren {
  user?: User;
}

/*
 * This component has been intentionally left empty.
 * As work continues, this component can be filled to contain any common styles
 * or components from the ads/components folder
 */

const WebPlusAd = connectUserAndChat(({
  user,
  className,
  children,
  ...rest
}: WebPlusAdProps) => {
  return <div className={className} {...rest}>
        {children}
      </div>;
});
export default WebPlusAd;